export const formatAssetCount = (num: number) =>
  num > 1 ? ` - ${num} Assets` : ` - ${num} Asset`;
